import { h, Component } from 'preact';

// modified by Vihang
// modified on 19/02/2022
// modification: toast1 working class added new logo for no internet

export default class NoInternet extends Component {

  refreshPage() {
    location.reload();
  }

  render({}, {}) {
    return (
      <div class="online-offline row">
        <section class="col-xs-6">
          <div class="toast1 displayed" style="bottom: 0px;">
            <div class="body nointernet display-flex justify-center">
              <svg class="leftImg" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86L3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z" /></svg>
              {/*
                modified : Ashutosh G
                modified : 20/06/2024
                modification : (T1778 BUG ID) error text change
              */}
              <p class="m-l-10">No Internet connection. Kindly refresh the page once your internet connection is back.</p>
            </div>
            {/* <svg class="rightImg" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zm-2 2c-1.08-1.08-2.36-1.85-3.72-2.33l3.02 3.02.7-.69zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24C7.79 10.89 6.27 11.74 5 13l2 2c1.35-1.35 3.11-2.04 4.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"/></svg> */}
            {/* <img src="/assets/icons/dashboard/Placeholder.svg" class="leftImg"/>
            <img src="/assets/icons/dashboard/Placeholder.svg" class="rightImg"/> */}
          </div>
        </section>
      </div>
    );
  }
}
